import camelCase from "lodash-es/camelCase";
import { IntlShape } from "react-intl";

import IntegrationService from "@mapmycustomers/shared/enum/integrations/IntegrationService";
import { EntityTypesSupportedByIntegrations } from "@mapmycustomers/shared/types/entity";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import { IntegrationFieldsMapping } from "@app/store/integrations";

import getEntityRequiredFieldsForIntegration from "./getEntityRequiredFieldsForIntegration";

const getStep2ErrorMessage = (
  intl: IntlShape,
  integrationFields: IntegrationFieldsMapping,
  syncedEntityTypes: EntityTypesSupportedByIntegrations[],
  service?: IntegrationService
): string | undefined => {
  let message = "";
  syncedEntityTypes.forEach((entityType) => {
    const mappedFields = new Set(integrationFields[entityType].map(({ mmcField }) => mmcField));
    const notMappedRequiredFields = getEntityRequiredFieldsForIntegration(entityType, service)
      .filter(({ name }: IField) => !mappedFields.has(name))
      .map(({ displayName }) => displayName);

    if (notMappedRequiredFields.length) {
      message += intl.formatMessage(
        {
          id: "integrations.edit.step2.requiredFieldNotSelected",
          defaultMessage:
            "You must match a CRM field to {fieldNames} in order to sync with {entityType, select, accounts {Companies} contacts {People} deals {Deals} crmActivities {Activities} other {Records}}.",
          description: "Integration mapping error - required field os not selected",
        },
        { entityType: camelCase(entityType), fieldNames: notMappedRequiredFields.join(", ") }
      );
    }
  });
  return message.length ? message : undefined;
};

export default getStep2ErrorMessage;
